import { CognitoUserPool, CognitoUserAttribute, CognitoUser } from 'amazon-cognito-identity-js';


const { 
    VITE_APP_AWS_REGION, VITE_APP_USER_POOL_ID, 
    VITE_APP_USER_POOL_APP_CLIENT_NAME, VITE_APP_USER_POOL_APP_CLIENT_ID, 
    VITE_APP_IDENTITY_POOL_ID 
} = import.meta.env;

const POOL_DATA = { UserPoolId: VITE_APP_USER_POOL_ID, ClientId: VITE_APP_USER_POOL_APP_CLIENT_ID };

export const userPool = new CognitoUserPool(POOL_DATA);




// EXTRA CODE 
export const getCurrentAuthenticatedUser = () => {
    return userPool.getCurrentUser();
}

export const logOutAws = () => {
  try {
    getCurrentAuthenticatedUser().signOut();
    localStorage.clear();
  } catch (error) {
    localStorage.clear();
    history.go("/signin");
  }
}

export const isUserAuthenticated = () => {
  const currentUser = userPool.getCurrentUser();

  return new Promise((resolve, reject) => {
    if (currentUser != null) {
      currentUser.getSession((err, session) => {
        if (err) {
          reject(err);
          return;
        }
        if (session.isValid()) {
          resolve(true); // User is authenticated
        } else {
          resolve(false); // Session is not valid, user is not authenticated
        }
      });
    } else {
      resolve(false); // No current user
    }
  });
};


